import React from 'react';

export const NexaPermissionTooltipContent = ({ showNexaEnabledOption }) => {
  return (
    <div>
      <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Nexa Permissions</div>
      <div style={{ marginBottom: '6px' }}>
        <strong>No</strong> - Nexa is disabled for this organization. No users or admins can access
        Nexa features.
      </div>
      <div style={{ marginBottom: '6px' }}>
        <strong>Use</strong> - Allows users to access and use Nexa features once it&apos;s enabled
        by the account admin.
      </div>
      {showNexaEnabledOption && (
        <div>
          <strong>Enable</strong> - Only admins can have this permission. Grants the ability to
          enable Nexa for the entire account after accepting Conviva&apos;s AI Acceptable Use
          Policy.
        </div>
      )}
    </div>
  );
};
